import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'KanziShortString',
    standalone: false
})
export class KanziShortStringPipe implements PipeTransform {
  transform(value: string | undefined, args?: number): number | string {
    if (!value) {
      return 0;
    }
    const length = value.length;
    let num: number | string = 0;

    if (length > 10) { 
      if (!parseInt(value)) {
        return value;
      } else {
        if (args && args > 0) {
          const sl = value.slice(length - args, length);
          //num = parseInt(sl);
          num = sl;
        } else {
          num = parseInt(value);
        }
      }
    } else {
      return value;
    }
    return num;
  }
}
